import { useEffect, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { _RawMaterialSupplier, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { Modal } from "../../../../theme/Component/Modal";
import { SelectProductEditor } from "../../Components/SelectProductEditor";
import { SelectorUmeasurement } from "../../../../bpm/config/Componentes/SelectorUmeasurement";
import { InputMoney } from "../../../../theme/Input/InputMoney";
import { AccountEditor } from "../../../../editor/AccountEditor";
import { toast } from "react-toastify";


interface Props {
    rawMaterial: number;
}

export const RawMaterialSupplier = ({ rawMaterial }: Props) => {

    const { lista, setLista, bean, setBean, instance, update, handleChange, deleteItemVoid } = useDataBean(_RawMaterialSupplier);

    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });


    useEffect(() => {
        getLista()
    }, [rawMaterial])

    const getLista = () => {
        instance.getRawMaterialSupplierCatalog(rawMaterial).then(
            (rta: any) => {
                setLista(rta)
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const editaItem = () => {
        update().then(
            (resp) => {
                getLista();
                setModal({ ...modal, "view": false })
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const deleteObjec = () => {
        deleteItemVoid(bean.IDRawMaterialSupplier).then(
            (resp) => {
                getLista();
                setModalC({ ...modalC, "view": false })
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const head = [
        { title: 'ID', property: 'IDRawMaterialSupplier', visible: true },
        { title: 'Proveedor', property: 'SupplierName', visible: true },
        { title: 'Producto Final', property: 'ProductName', visible: true },
        { title: 'Código de Referencia-SKU', property: 'StockKeepingUnit', visible: true },
        { title: 'Unidad de Medida', property: 'MeasurementUnitName', visible: true },
        { title: 'Costo Unitario', property: 'UnitaryCost', visible: true },
        { title: 'Empleado', property: 'EmployeeName', visible: true },
    ]

    const create = () => {
        setBean({
            IDEmployee: _single.getAccountID(),
            IDRawMaterial: rawMaterial,
        });
        setModal({ ...modal, "view": true, "name": "Agregar Proveedor de Materia Prima" });
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModal({ ...modal, "view": true, "name": "Editar Proveedor de Materia Prima" }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true, "name": `Eliminar Proveedor de Materia Prima` }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const [missingFields, setMissingFields] = useState<string[]>([]);

    const validateData = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            editaItem();
        }
    }

    const validateForm = () => {
        const requiredFields = [
            "IDAccount", "IDProduct", "StockKeepingUnit", "IDMeasurementUnit"
        ];

        let missing = [];
        for (let field of requiredFields) {
            if (bean[field] === null || bean[field] === undefined || bean[field] === "") {
                missing.push(field);
            }
        }
        setMissingFields(missing);
        return missing.length;
    };

    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable listButtons={listaBotones()} head={head} body={lista} rowSet={setBean} iconButtons={iconButtonsItem} />
            </div>


            <div className="col-md-12">
                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteObjec}>
                    <strong>Eliminar Informacion de {bean.IDRawMaterialSupplier} - {bean.SupplierName}</strong>
                </ModalConfirm>
            </div>

            <div className="col-md-12">
                <Modal modal={modal} updateModal={setModal} eventModal={validateData}>
                    <div className="row">
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('IDAccount') ? 'has-error' : ''}`}>Proveedor</label>
                            <AccountEditor idAccount={bean.IDAccount} label=" " onChange={(e) => { setBean({ ...bean, "IDAccount": e.IDAccount }) }} />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('IDProduct') ? 'has-error' : ''}`}>Producto FInal</label>
                            <SelectProductEditor label=" " value={bean.IDProduct} onChange={(e) => { setBean({ ...bean, "IDProduct": e.IDProduct }) }} />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('StockKeepingUnit') ? 'has-error' : ''}`}>Código de Referencia-SKU</label>
                            <input type="text" name="StockKeepingUnit" className="form-control" value={bean.StockKeepingUnit} onChange={handleChange} />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('IDMeasurementUnit') ? 'has-error' : ''}`}>Unidad de Medida</label>
                            <SelectorUmeasurement idSelector={bean.IDMeasurementUnit} onChange={(e) => { setBean({ ...bean, "IDMeasurementUnit": e }) }} titulo=" " />
                        </div>
                        <div className="col-md-6">
                            <InputMoney _value={bean.UnitaryCost} onChange={(e) => { setBean({ ...bean, "UnitaryCost": e }) }} _label="Costo Unitario" />
                        </div>
                    </div>
                </Modal>
            </div>
        </div >
    )
}



